/* @flow */

import * as React from 'react';

// $FlowIgnore ReactContext not supported
export const PageWrapperContext = React.createContext('pageContainer');
